var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "empty-messages d-flex flex-column align-center fill-height",
      class: {
        "justify-center pa-6": !_vm.ancorarNoTopo,
        "empty-messages--ancorada": _vm.ancorarNoTopo
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "empty-messages__coluna d-flex flex-column align-start w-100"
        },
        [
          _c("ChatHero", {
            staticClass: "empty-messages__hero",
            attrs: { saudacao: _vm.saudacao, headline: _vm.headline }
          }),
          _vm.$slots.descricao
            ? _c(
                "div",
                { staticClass: "empty-messages__descricao w-100" },
                [_vm._t("descricao")],
                2
              )
            : _vm._e(),
          _vm.$slots.composer
            ? _c(
                "div",
                { staticClass: "empty-messages__composer w-100" },
                [_vm._t("composer")],
                2
              )
            : _vm._e(),
          _vm.moduloEmFoco
            ? _c("AcoesPorModulo", {
                ref: "acoesDoModulo",
                staticClass: "w-100",
                attrs: {
                  layout: _vm.layoutDoModuloEmFoco,
                  modulos: [_vm.moduloEmFoco],
                  densidade: _vm.densidadeDasAcoes
                },
                on: {
                  use: _vm.useSuggestion,
                  voltar: function($event) {
                    return _vm.$emit("limpar-ferramenta")
                  },
                  "sair-para-o-campo": function($event) {
                    return _vm.$emit("focar-composer")
                  }
                }
              })
            : _vm.temAcoes || _vm.avisoDasAcoes
            ? _c("AcoesPorModulo", {
                ref: "acoesDoModulo",
                staticClass: "w-100 acoes-modulo--proxima-do-input",
                attrs: {
                  modulos: _vm.acoes,
                  densidade: _vm.densidadeDasAcoes,
                  layout: _vm.layoutDasAcoes,
                  aviso: _vm.avisoDasAcoes,
                  "aviso-acao": _vm.avisoDasAcoesAcao
                },
                on: {
                  use: _vm.useSuggestion,
                  "usar-comando": function($event) {
                    return _vm.$emit("usar-comando", $event)
                  },
                  "aviso-acao": function($event) {
                    return _vm.$emit("aviso-das-acoes-acao")
                  },
                  "sair-para-o-campo": function($event) {
                    return _vm.$emit("focar-composer")
                  }
                }
              })
            : _vm.modoDeSugestao === "lista" && _vm.hasSuggestions
            ? _c("SugestoesDeExemplo", {
                staticClass: "w-100",
                attrs: { sugestoes: _vm.promptSuggestions },
                on: { use: _vm.useSuggestion }
              })
            : !_vm.ocultarSugestoes
            ? [
                _vm.loading
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-center" },
                      [
                        _c("v-progress-circular", {
                          attrs: {
                            indeterminate: "",
                            color: "primary",
                            size: "24"
                          }
                        })
                      ],
                      1
                    )
                  : _vm.hasSuggestions
                  ? _c("SuggestionChips", {
                      staticClass: "w-100",
                      attrs: { sugestoes: _vm.promptSuggestions },
                      on: { use: _vm.useSuggestion }
                    })
                  : _c(
                      "div",
                      {
                        staticClass:
                          "sem-sugestoes az-text-secondary az-size-12 az-muted"
                      },
                      [_vm._v(" " + _vm._s(_vm.textoSemSugestoes) + " ")]
                    )
              ]
            : _vm._e(),
          _vm.$slots.rodape
            ? _c(
                "div",
                { staticClass: "empty-messages__rodape w-100" },
                [_vm._t("rodape")],
                2
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }